import React from "react";
import Header from "../HeaderOne/Main";
import Footer from "../FooterOne/Main";
import Bredcrumb from "../Breadcrumb/Main";
import GoogleMaps from "../Mencontact/GoogleMaps";
import ContactPage from "../Mencontact/ContactPage";
import ContactBanner from "../Mencontact/ContactBanner";

function Main() {
  return (
    <div>
      <Header />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <div className="page-wrapper-bg-3" />
            <main className="site-main">
              <Bredcrumb title="Home" subtitle="Contact Us" />
              <ContactBanner />
              <ContactPage />
              <GoogleMaps />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
